export interface ICprScore {
    centerId: number,
    centerAlias: string,
    compatiblePairCount: number,
    favorablePairCount: number,
    favorableCompatiblePairCount: number,
    includedCount: number,
    allDonorsProtected: number | boolean | null,
    allDonorsProtectedEndDate: string | null,
    vouchersLast12: number,
    score: number
}